import { Socket, connect as io } from "socket.io-client";
import { Middleware } from 'redux'
import {
    agentMonitorWSConnecting,
    agentMonitorRefreshData
} from './agentMonitorSlice';
import { IUpdateData } from "./types";

const agentMonitorMiddleware: Middleware = store => {
    let socket: Socket;
    return next => action => {
        const { user } = store.getState().auth;
        const url = process.env.REACT_APP_AGENTMONITOR_SOCKET ?? "";
        const domain = new URL(url)
        const pathname = "/wss/agent-monitor/";
        const cleandomain = `${domain.hostname}:${domain.port}`;
        const accessToken = localStorage.getItem("access-token");

        if (agentMonitorWSConnecting.match(action)) {

            if (user?.deviceId) {
                if (socket === undefined) {
                    socket = io(cleandomain, {
                        path: pathname,
                        transports: ["websocket", "polling", "flashsocket"],
                        query: { token: accessToken }
                    });
                    socket.on("update-data", (data: IUpdateData) => {
                        store.dispatch(agentMonitorRefreshData(data));
                    });
                    socket.on("update-call-data", (data: IUpdateData) => {
                        store.dispatch(agentMonitorRefreshData(data));
                    });
                    socket.on("connect", () => {
                        console.log('connected agentmonitor');
                        store.dispatch(agentMonitorRefreshData({ type: "USER_STATE", payload: {} }));
                    });
                    socket.on("disconnect", () => {
                        console.log('disconnected agentmonitor');
                    });
                }
            }

        }

        next(action);

    }
}

export default agentMonitorMiddleware;
